export function parseHours(rawHours: string | undefined) {
  if (!rawHours) return undefined
  const rawHoursNormalized = rawHours.replace(',', '.')
  return Number(rawHoursNormalized || undefined)
}
